import { Row, Col } from 'react-bootstrap';
import logo from '../logo.png';

const Logo = () => {
  return (
    <Row className="mt-2 text-center">
      <Col xs={11} s={9} md={6} className="mx-auto">
        <img className="mw-100 h-100" alt="" src={logo} />
      </Col>
    </Row>
  );
};

export default Logo;
